// src/features/admin/services/adminCategoryService.js
import { 
  collection, 
  doc, 
  getDocs, 
  getDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  orderBy,
  Timestamp 
} from 'firebase/firestore';
import { db } from '../../../services/firebase';

const CATEGORIES_COLLECTION = 'categories';

export const CategoryService = {
  // Get all categories
  async getCategories() {
    try {
      const categoriesRef = collection(db, CATEGORIES_COLLECTION);
      const q = query(categoriesRef, orderBy('name', 'asc'));
      const querySnapshot = await getDocs(q);
      
      const categories = [];
      querySnapshot.forEach((doc) => {
        categories.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      return categories;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw new Error('Failed to fetch categories');
    }
  },

  // Get a single category by ID
  async getCategoryById(categoryId) {
    try {
      const categoryRef = doc(db, CATEGORIES_COLLECTION, categoryId);
      const categorySnap = await getDoc(categoryRef);
      
      if (!categorySnap.exists()) {
        throw new Error('Category not found');
      }
      
      return {
        id: categorySnap.id,
        ...categorySnap.data()
      };
    } catch (error) {
      console.error('Error fetching category:', error);
      throw new Error('Failed to fetch category');
    }
  },

  // Add a new category
  async addCategory(categoryData) {
    try {
      const categoriesRef = collection(db, CATEGORIES_COLLECTION);
      const newCategory = {
        name: categoryData.name,
        slug: categoryData.name.toLowerCase().replace(/\s+/g, '-'),
        isActive: true,
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now()
      };
      
      const docRef = await addDoc(categoriesRef, newCategory);
      return {
        id: docRef.id,
        ...newCategory
      };
    } catch (error) {
      console.error('Error adding category:', error);
      throw new Error('Failed to add category');
    }
  },

  // Update a category
  async updateCategory(categoryId, categoryData) {
    try {
      const categoryRef = doc(db, CATEGORIES_COLLECTION, categoryId);
      const updateData = {
        ...categoryData,
        updatedAt: Timestamp.now()
      };
      
      await updateDoc(categoryRef, updateData);
      return {
        id: categoryId,
        ...updateData
      };
    } catch (error) {
      console.error('Error updating category:', error);
      throw new Error('Failed to update category');
    }
  },

  // Delete a category
  async deleteCategory(categoryId) {
    try {
      const categoryRef = doc(db, CATEGORIES_COLLECTION, categoryId);
      await deleteDoc(categoryRef);
    } catch (error) {
      console.error('Error deleting category:', error);
      throw new Error('Failed to delete category');
    }
  }
};

export default CategoryService;

